/**
 * @generated SignedSource<<182a47764ca1b21b06e6282e3cf2be6d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type interiorsPhotosTracking_searchBrowsePhoto$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "interiorsPhotosTracking_searchBrowsePhoto";
};
export type interiorsPhotosTracking_searchBrowsePhoto$key = {
  readonly " $data"?: interiorsPhotosTracking_searchBrowsePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"interiorsPhotosTracking_searchBrowsePhoto">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "interiorsPhotosTracking_searchBrowsePhoto"
};

(node as any).hash = "da5a623af0579fdc3f6ee15d77b9b89b";

export default node;
